var _defs, _g, _g2, _g3, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgOscura(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "img-oscura",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 480.317,
    height: 467.923,
    viewBox: "0 0 480.317 467.923",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24584",
    "data-name": "Rect\\xE1ngulo 24584",
    width: 480.317,
    height: 467.923,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24566",
    "data-name": "Rect\\xE1ngulo 24566",
    width: 435.269,
    height: 371.157,
    transform: "translate(0.174 0.629)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24568",
    "data-name": "Rect\\xE1ngulo 24568",
    width: 90.599,
    height: 77.476,
    transform: "translate(71.798 322.507)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24569",
    "data-name": "Rect\\xE1ngulo 24569",
    width: 90.599,
    height: 77.476,
    transform: "translate(51.245 334.905)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24570",
    "data-name": "Rect\\xE1ngulo 24570",
    width: 128.963,
    height: 66.392,
    transform: "translate(307.03 391.526)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24572",
    "data-name": "Rect\\xE1ngulo 24572",
    width: 10.293,
    height: 13.291,
    transform: "translate(79.54 323.977)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24573",
    "data-name": "Rect\\xE1ngulo 24573",
    width: 6.654,
    height: 10.863,
    transform: "translate(79.54 324.14)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24574",
    "data-name": "Rect\\xE1ngulo 24574",
    width: 68.152,
    height: 63.858,
    transform: "translate(79.54 330.165)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24575",
    "data-name": "Rect\\xE1ngulo 24575",
    width: 10.293,
    height: 13.291,
    transform: "translate(58.523 336.117)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24576",
    "data-name": "Rect\\xE1ngulo 24576",
    width: 6.654,
    height: 10.862,
    transform: "translate(58.523 336.281)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24577",
    "data-name": "Rect\\xE1ngulo 24577",
    width: 68.151,
    height: 63.17,
    transform: "translate(58.524 342.305)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24579",
    "data-name": "Rect\\xE1ngulo 24579",
    width: 142.926,
    height: 311.556,
    transform: "translate(296.243 138.221)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24581",
    "data-name": "Rect\\xE1ngulo 24581",
    width: 140.416,
    height: 141.335,
    transform: "translate(64.787 96.261)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24582",
    "data-name": "Rect\\xE1ngulo 24582",
    width: 128.839,
    height: 83.816,
    transform: "translate(70.236 65.064)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12940",
    "data-name": "Grupo 12940",
    clipPath: "url(#clip-path)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12895",
    "data-name": "Grupo 12895"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12894",
    "data-name": "Grupo 12894",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9559",
    "data-name": "Trazado 9559",
    d: "M478.4,227.131c-5.18-53.7-32.15-107.275-55.416-136.862-98.611-125.4-296.53-125.157-390.8,32.346C5.592,167.041-11.093,265.809,8.654,338.862c25.271,93.493,124.856,129.906,235.6,129.046,103.469-.8,184.826-45.79,215.289-107.937,19.061-38.888,24.038-79.14,18.858-132.84",
    fill: "#1148a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9560",
    "data-name": "Trazado 9560",
    d: "M32.182,122.615C5.592,167.041-11.093,265.809,8.654,338.862A148.756,148.756,0,0,0,28.487,382.9h0l109.949-63.471,93.7-54.09,220.124-127.07v0c-9.165-19.031-19.544-35.621-29.279-48-98.61-125.4-296.53-125.157-390.8,32.346",
    fill: "#08204a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12893",
    "data-name": "Grupo 12893",
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12892",
    "data-name": "Grupo 12892"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12891",
    "data-name": "Grupo 12891",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9561",
    "data-name": "Trazado 9561",
    d: "M32.361,198.058a8.52,8.52,0,0,0,3.856-6.679v-7.8c0-2.459-1.726-3.456-3.856-2.226l-25.47,14.7c-1.174,6.036-2.215,12.217-3.11,18.5Z",
    fill: "#1148a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9562",
    "data-name": "Trazado 9562",
    d: "M23.274,140.383l9.087-5.246a8.523,8.523,0,0,0,3.856-6.68v-7.8a2.6,2.6,0,0,0-1.273-2.551q-1.394,2.237-2.762,4.511a147.034,147.034,0,0,0-8.908,17.768",
    fill: "#1148a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9563",
    "data-name": "Trazado 9563",
    d: "M71.107,71.775l7.7-4.443a8.527,8.527,0,0,0,3.855-6.667q-5.894,5.314-11.551,11.11",
    fill: "#1148a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9564",
    "data-name": "Trazado 9564",
    d: "M36.217,273.449v-7.8c0-2.459-1.726-3.455-3.856-2.226L.324,281.916Q.678,290,1.439,297.981l30.922-17.853a8.523,8.523,0,0,0,3.856-6.679",
    fill: "#1148a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9565",
    "data-name": "Trazado 9565",
    d: "M129.1,156.989v-7.8c0-2.459-1.726-3.456-3.856-2.227l-35.7,20.61a8.525,8.525,0,0,0-3.857,6.679v7.8c0,2.459,1.727,3.456,3.856,2.226l35.7-20.609a8.523,8.523,0,0,0,3.856-6.679",
    fill: "#1148a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9566",
    "data-name": "Trazado 9566",
    d: "M9.569,342q1.129,3.865,2.422,7.6V344.73c0-1.873-1-2.889-2.422-2.728",
    fill: "#1148a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9567",
    "data-name": "Trazado 9567",
    d: "M9.815,250.638a8.526,8.526,0,0,0,3.856-6.679v-7.8c0-2.459-1.727-3.456-3.856-2.226L1.1,238.96Q.441,247.537.173,256.2Z",
    fill: "#1148a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9568",
    "data-name": "Trazado 9568",
    d: "M135.992,116.473l35.7-20.609a8.523,8.523,0,0,0,3.856-6.679v-7.8c0-2.459-1.726-3.456-3.856-2.226l-35.7,20.609a8.522,8.522,0,0,0-3.856,6.679v7.8c0,2.459,1.725,3.456,3.856,2.226",
    fill: "#1148a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9569",
    "data-name": "Trazado 9569",
    d: "M159.889,246.241l35.7-20.609a8.524,8.524,0,0,0,3.856-6.68v-7.8c0-2.46-1.726-3.456-3.856-2.227l-35.7,20.61a8.522,8.522,0,0,0-3.856,6.679v7.8c0,2.46,1.726,3.456,3.856,2.227",
    fill: "#1148a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9570",
    "data-name": "Trazado 9570",
    d: "M67,94.6l35.7-20.609a8.522,8.522,0,0,0,3.857-6.679v-7.8c0-2.459-1.726-3.456-3.857-2.226L67,77.895a8.524,8.524,0,0,0-3.857,6.679v7.8c0,2.459,1.726,3.456,3.856,2.226",
    fill: "#1148a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9571",
    "data-name": "Trazado 9571",
    d: "M132.136,155.282c0,2.459,1.726,3.456,3.856,2.227l35.7-20.61a8.522,8.522,0,0,0,3.856-6.679v-7.8c0-2.459-1.726-3.456-3.856-2.226l-35.7,20.609a8.526,8.526,0,0,0-3.856,6.679Z",
    fill: "#1148a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9572",
    "data-name": "Trazado 9572",
    d: "M78.8,255.8l-35.7,20.609a8.523,8.523,0,0,0-3.856,6.679v7.8c0,2.459,1.726,3.456,3.856,2.226l35.7-20.609a8.523,8.523,0,0,0,3.856-6.679v-7.8c0-2.459-1.726-3.456-3.856-2.226",
    fill: "#1148a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9573",
    "data-name": "Trazado 9573",
    d: "M221.74.629a230.011,230.011,0,0,0-31.85,4.608l-7.455,4.3a8.521,8.521,0,0,0-3.857,6.678v7.8c0,2.46,1.727,3.456,3.856,2.227l35.7-20.61A8.6,8.6,0,0,0,221.74.629",
    fill: "#1148a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9574",
    "data-name": "Trazado 9574",
    d: "M106.556,231.456v-7.8c0-2.459-1.726-3.456-3.856-2.226L67,242.036a8.524,8.524,0,0,0-3.857,6.679v7.8c0,2.459,1.726,3.456,3.856,2.226l35.7-20.609a8.523,8.523,0,0,0,3.856-6.679",
    fill: "#1148a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9575",
    "data-name": "Trazado 9575",
    d: "M153,286.757v-7.8c0-2.459-1.726-3.456-3.856-2.226l-35.7,20.609a8.523,8.523,0,0,0-3.856,6.679v7.8c0,2.459,1.727,3.456,3.856,2.227l35.7-20.61A8.522,8.522,0,0,0,153,286.757",
    fill: "#1148a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9576",
    "data-name": "Trazado 9576",
    d: "M275.319,200.3l35.7-20.609a8.524,8.524,0,0,0,3.857-6.679v-7.8c0-2.459-1.727-3.456-3.857-2.226l-35.7,20.609a8.523,8.523,0,0,0-3.856,6.679v7.8c0,2.459,1.726,3.456,3.856,2.226",
    fill: "#1148a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9577",
    "data-name": "Trazado 9577",
    d: "M299.216,206.968l35.7-20.61a8.523,8.523,0,0,0,3.856-6.678v-7.8c0-2.46-1.727-3.456-3.856-2.227l-35.7,20.61a8.523,8.523,0,0,0-3.856,6.679v7.8c0,2.46,1.726,3.456,3.856,2.227",
    fill: "#1148a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9578",
    "data-name": "Trazado 9578",
    d: "M271.464,90.158v7.8c0,2.459,1.725,3.456,3.855,2.226l35.7-20.609a8.524,8.524,0,0,0,3.857-6.679V65.1c0-2.459-1.727-3.456-3.857-2.227l-35.7,20.61a8.521,8.521,0,0,0-3.855,6.679",
    fill: "#1148a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9579",
    "data-name": "Trazado 9579",
    d: "M295.677,15.91a8.525,8.525,0,0,0-3.856,6.68v7.8c0,2.459,1.726,3.455,3.856,2.225l28.345-16.364q-8.916-3.522-18.062-6.28Z",
    fill: "#1148a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9580",
    "data-name": "Trazado 9580",
    d: "M288.47,55.267l-35.7,20.609a8.523,8.523,0,0,0-3.856,6.679v7.8c0,2.459,1.726,3.456,3.856,2.226l35.7-20.609a8.523,8.523,0,0,0,3.856-6.679v-7.8c0-2.459-1.726-3.456-3.856-2.226",
    fill: "#1148a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9581",
    "data-name": "Trazado 9581",
    d: "M338.769,89.806c0-2.459-1.727-3.456-3.856-2.226l-35.7,20.609a8.523,8.523,0,0,0-3.856,6.679v7.8c0,2.459,1.726,3.456,3.856,2.227l35.7-20.61a8.526,8.526,0,0,0,3.856-6.679Z",
    fill: "#1148a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9582",
    "data-name": "Trazado 9582",
    d: "M427.8,116.112l-35.7,20.609a8.527,8.527,0,0,0-3.857,6.679v7.8c0,2.459,1.726,3.456,3.856,2.226l35.7-20.609a8.526,8.526,0,0,0,3.856-6.679v-7.8c0-2.459-1.727-3.456-3.856-2.226",
    fill: "#1148a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9583",
    "data-name": "Trazado 9583",
    d: "M427.284,95.969l-12.637,7.321a8.526,8.526,0,0,0-3.856,6.679v7.8c0,2.459,1.726,3.456,3.856,2.226l20.8-12.036c-2.722-4.27-5.454-8.278-8.159-11.993",
    fill: "#1148a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9584",
    "data-name": "Trazado 9584",
    d: "M245.883,151.147v-7.8c0-2.46-1.726-3.456-3.856-2.227l-35.7,20.61a8.523,8.523,0,0,0-3.856,6.678v7.8c0,2.459,1.726,3.455,3.856,2.226l35.7-20.609a8.522,8.522,0,0,0,3.856-6.68",
    fill: "#1148a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9585",
    "data-name": "Trazado 9585",
    d: "M381.354,60.811l-35.7,20.609A8.526,8.526,0,0,0,341.8,88.1v7.8c0,2.46,1.726,3.457,3.856,2.227l35.7-20.61a8.52,8.52,0,0,0,3.857-6.679v-7.8c0-2.46-1.726-3.456-3.857-2.227",
    fill: "#1148a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9586",
    "data-name": "Trazado 9586",
    d: "M218.13,216.527l-35.7,20.609a8.523,8.523,0,0,0-3.856,6.679v7.8c0,2.459,1.727,3.456,3.856,2.226l35.7-20.609a8.523,8.523,0,0,0,3.856-6.679v-7.8c0-2.459-1.726-3.456-3.856-2.226",
    fill: "#1148a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9587",
    "data-name": "Trazado 9587",
    d: "M32.032,365.875a8.523,8.523,0,0,0,3.856-6.679v-7.8c0-2.459-1.726-3.456-3.856-2.226L15.5,358.709q2.859,6.768,6.289,13.077Z",
    fill: "#1148a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9588",
    "data-name": "Trazado 9588",
    d: "M364.349,136.738v7.8c0,2.459,1.725,3.456,3.855,2.226l35.7-20.609a8.527,8.527,0,0,0,3.857-6.679v-7.8c0-2.459-1.728-3.456-3.857-2.226l-35.7,20.609a8.519,8.519,0,0,0-3.857,6.679",
    fill: "#1148a6"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12906",
    "data-name": "Grupo 12906"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12905",
    "data-name": "Grupo 12905",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12898",
    "data-name": "Grupo 12898",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12897",
    "data-name": "Grupo 12897"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12896",
    "data-name": "Grupo 12896",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9589",
    "data-name": "Trazado 9589",
    d: "M158.628,387.286a13.158,13.158,0,0,0-1.234-.621l.15-.087-69.991-38.3V322.507L71.8,331.6v25.773L136.736,392.9c.144,1.778,1.376,3.55,3.74,4.9,5,2.9,13.132,2.9,18.152,0,2.518-1.444,3.77-3.36,3.77-5.268,0-1.893-1.252-3.808-3.77-5.252"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12901",
    "data-name": "Grupo 12901",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12900",
    "data-name": "Grupo 12900"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12899",
    "data-name": "Grupo 12899",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9590",
    "data-name": "Trazado 9590",
    d: "M138.075,399.684a13.171,13.171,0,0,0-1.234-.621l.15-.087L67,360.679V334.9l-15.754,9.089v25.773L116.184,405.3c.144,1.778,1.375,3.55,3.739,4.9,5,2.9,13.132,2.9,18.152,0,2.518-1.444,3.77-3.36,3.77-5.268s-1.252-3.808-3.77-5.252"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12904",
    "data-name": "Grupo 12904",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12903",
    "data-name": "Grupo 12903"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12902",
    "data-name": "Grupo 12902",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9591",
    "data-name": "Trazado 9591",
    d: "M376.313,445.237a86.549,86.549,0,0,0-22.321-9.462c-10.06-2.883-21.956-5-30.514-8.485-11.123-4.532-16.1-11.241-16.435-18.681-.19-4.213,1.6-9.182,10.588-13.635a33.516,33.516,0,0,1,8.292-2.866,35.272,35.272,0,0,1,12.188-.1c18.113,2.685,26.665,9.66,33.638,16.634s14.708,10.469,28.493,15.976c5.9,2.356,12.185,4.588,17.789,7.028l.136.06a67.28,67.28,0,0,1,8.208,3.768c3.666,2.3,6.955,4.745,8.577,7.607s1.513,6.178-1.5,9.714a9.562,9.562,0,0,1-3.719,2.7,27.43,27.43,0,0,1-5.694,1.581,52.249,52.249,0,0,1-11.624.785,54.957,54.957,0,0,1-9.155-1.251,77.954,77.954,0,0,1-26.945-11.378"
  }))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12926",
    "data-name": "Grupo 12926"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12925",
    "data-name": "Grupo 12925",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9592",
    "data-name": "Trazado 9592",
    d: "M84.7,318.744l5.136,2.965L79.54,339.537l-5.146-2.971h0c-1.317-.76-2.132-2.391-2.132-4.711a16.088,16.088,0,0,1,7.279-12.607c2.015-1.163,3.838-1.271,5.156-.5",
    fill: "#375a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9593",
    "data-name": "Trazado 9593",
    d: "M77.408,334.825a16.091,16.091,0,0,1,7.279-12.607c4.019-2.321,7.278-.44,7.277,4.2a16.088,16.088,0,0,1-7.279,12.607c-4.019,2.321-7.277.44-7.277-4.2",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12909",
    "data-name": "Grupo 12909",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12908",
    "data-name": "Grupo 12908"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12907",
    "data-name": "Grupo 12907",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9594",
    "data-name": "Trazado 9594",
    d: "M79.54,333.594a11.376,11.376,0,0,1,5.146-8.914c2.843-1.641,5.147-.311,5.147,2.971a11.374,11.374,0,0,1-5.147,8.914c-2.842,1.641-5.146.311-5.146-2.971"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12912",
    "data-name": "Grupo 12912",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12911",
    "data-name": "Grupo 12911"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12910",
    "data-name": "Grupo 12910",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9595",
    "data-name": "Trazado 9595",
    d: "M86.194,325.55a11.375,11.375,0,0,1-5.147,8.914,5.341,5.341,0,0,1-1.316.539,5.393,5.393,0,0,1-.191-1.409,11.376,11.376,0,0,1,5.146-8.914A5.4,5.4,0,0,1,86,324.141a5.4,5.4,0,0,1,.191,1.409"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9596",
    "data-name": "Trazado 9596",
    d: "M81.049,336.935l60.329,34.871a1.83,1.83,0,0,1,.915,1.584v20.633h14.561v-17.9h0V371.47a13.069,13.069,0,0,0-6.534-11.316L88.331,324.326a3.608,3.608,0,0,0-3.645.354,11.376,11.376,0,0,0-5.146,8.914,3.612,3.612,0,0,0,1.513,3.333Z",
    fill: "#375a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9597",
    "data-name": "Trazado 9597",
    d: "M156.852,372.158a13.042,13.042,0,0,0-.364-3.035c.052.4.21,3.176-5.145,4.956-5.778,1.921-9.049,0-9.049,0v19.944h14.561V376.808h0Z",
    fill: "#2b454e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12915",
    "data-name": "Grupo 12915",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12914",
    "data-name": "Grupo 12914"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12913",
    "data-name": "Grupo 12913",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9598",
    "data-name": "Trazado 9598",
    d: "M81.049,336.935l60.329,34.871a1.83,1.83,0,0,1,.915,1.584v20.633h5.4V378.637h0v-2a13.065,13.065,0,0,0-6.532-11.316L80.331,330.165a9.553,9.553,0,0,0-.791,3.429,3.612,3.612,0,0,0,1.513,3.333Z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9599",
    "data-name": "Trazado 9599",
    d: "M159.882,385.75V391.7c0,1.534-1.007,3.069-3.031,4.229a16.093,16.093,0,0,1-14.6,0c-2.024-1.16-3.03-2.7-3.03-4.216V385.75h3.069a2.917,2.917,0,0,0,.967,2.1c.078.077.155.155.245.232a6.379,6.379,0,0,0,.89.645,11.362,11.362,0,0,0,10.316,0,6.441,6.441,0,0,0,.89-.645c.09-.077.167-.155.245-.232a2.97,2.97,0,0,0,1.006-2.1Z",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9600",
    "data-name": "Trazado 9600",
    d: "M159.882,385.75c0,1.522-1.007,3.056-3.031,4.217a16.173,16.173,0,0,1-14.6,0c-2.024-1.161-3.03-2.7-3.03-4.217s1.006-3.056,3.03-4.217c.013-.013.026-.013.039-.026v4.243a2.917,2.917,0,0,0,.967,2.1c.078.077.155.155.245.232a6.379,6.379,0,0,0,.89.645,11.362,11.362,0,0,0,10.316,0,6.441,6.441,0,0,0,.89-.645c.09-.077.167-.155.245-.232a2.97,2.97,0,0,0,1.006-2.1v-4.217c2.024,1.161,3.031,2.7,3.031,4.217",
    fill: "#375a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9601",
    "data-name": "Trazado 9601",
    d: "M63.68,330.885l5.135,2.965L58.522,351.678l-5.145-2.971h0c-1.317-.76-2.132-2.391-2.132-4.712a16.088,16.088,0,0,1,7.279-12.606c2.015-1.163,3.838-1.271,5.156-.5",
    fill: "#375a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9602",
    "data-name": "Trazado 9602",
    d: "M56.391,346.965a16.088,16.088,0,0,1,7.279-12.607c4.019-2.321,7.278-.44,7.277,4.2a16.088,16.088,0,0,1-7.279,12.607c-4.019,2.321-7.277.439-7.277-4.2",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12918",
    "data-name": "Grupo 12918",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12917",
    "data-name": "Grupo 12917"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12916",
    "data-name": "Grupo 12916",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9603",
    "data-name": "Trazado 9603",
    d: "M58.523,345.734a11.376,11.376,0,0,1,5.146-8.914c2.843-1.641,5.147-.311,5.147,2.971a11.38,11.38,0,0,1-5.147,8.914c-2.842,1.641-5.146.311-5.146-2.971"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12921",
    "data-name": "Grupo 12921",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12920",
    "data-name": "Grupo 12920"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12919",
    "data-name": "Grupo 12919",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9604",
    "data-name": "Trazado 9604",
    d: "M65.177,337.69a11.374,11.374,0,0,1-5.146,8.914,5.349,5.349,0,0,1-1.317.539,5.393,5.393,0,0,1-.191-1.409,11.377,11.377,0,0,1,5.147-8.914,5.4,5.4,0,0,1,1.316-.539,5.393,5.393,0,0,1,.191,1.409"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9605",
    "data-name": "Trazado 9605",
    d: "M60.032,349.075l60.33,34.871a1.828,1.828,0,0,1,.914,1.584v5.047l0,14.9h14.56V388.259h0V383.61a13.067,13.067,0,0,0-6.532-11.316L67.315,336.466a3.607,3.607,0,0,0-3.646.354,11.378,11.378,0,0,0-5.145,8.914,3.609,3.609,0,0,0,1.513,3.333Z",
    fill: "#375a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9606",
    "data-name": "Trazado 9606",
    d: "M135.834,383.61a13.041,13.041,0,0,0-.364-3.035c.052.4.21,3.176-5.145,4.956-5.778,1.921-9.049,0-9.049,0v19.944h14.561V388.26h0Z",
    fill: "#2b454e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12924",
    "data-name": "Grupo 12924",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12923",
    "data-name": "Grupo 12923"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12922",
    "data-name": "Grupo 12922",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9607",
    "data-name": "Trazado 9607",
    d: "M60.032,349.075l60.33,34.871a1.828,1.828,0,0,1,.914,1.584v5.047l0,14.9h5.4v-14.7h0v-2a13.068,13.068,0,0,0-6.533-11.315L59.313,342.3a9.565,9.565,0,0,0-.789,3.429,3.609,3.609,0,0,0,1.513,3.333Z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9608",
    "data-name": "Trazado 9608",
    d: "M138.864,397.89v5.945c0,1.534-1.006,3.069-3.03,4.229a16.092,16.092,0,0,1-14.6,0c-2.024-1.16-3.03-2.7-3.03-4.216V397.89h3.069a2.921,2.921,0,0,0,.967,2.1c.078.077.155.155.245.232a6.44,6.44,0,0,0,.89.645,11.362,11.362,0,0,0,10.316,0,6.378,6.378,0,0,0,.89-.645c.09-.077.168-.155.245-.232a2.97,2.97,0,0,0,1.006-2.1Z",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9609",
    "data-name": "Trazado 9609",
    d: "M138.864,397.89c0,1.522-1.006,3.056-3.03,4.217a16.173,16.173,0,0,1-14.6,0c-2.024-1.161-3.03-2.7-3.03-4.217s1.006-3.056,3.03-4.217c.013-.012.026-.012.039-.026v4.243a2.921,2.921,0,0,0,.967,2.1c.078.077.155.155.245.232a6.44,6.44,0,0,0,.89.645,11.362,11.362,0,0,0,10.316,0,6.378,6.378,0,0,0,.89-.645c.09-.077.168-.155.245-.232a2.97,2.97,0,0,0,1.006-2.1v-4.217c2.024,1.161,3.03,2.7,3.03,4.217",
    fill: "#375a64"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12931",
    "data-name": "Grupo 12931"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12930",
    "data-name": "Grupo 12930",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9610",
    "data-name": "Trazado 9610",
    d: "M422.012,244.157l-9.745-23.108c-4.66-11.914-2.9-28.015-2.9-28.015,5.61-.1,10.868,1.8,14.5,8.388s10.821,30.045,12.467,35.093a47.088,47.088,0,0,1,2.394,13.566c.32,5.873-1.177,16.7-1.564,22.55-.178,2.706-.156,5.3-.146,8.037.011,2.852-.719,5.6-1.1,8.424a7.644,7.644,0,0,1-1.654,3.641c-.543.674-1.4.892-1.918,1.527-.534.656-.5,1.558-1.27,2.139-.858.647-2,.551-2.733,1.19a24.6,24.6,0,0,1-2.243,2.136,5.313,5.313,0,0,0-1.93,1.649c-.429.692-.707,2.111-1.7,2.194-1.112.093-1.482-.93-1.707-1.831a8.486,8.486,0,0,1,.827-5.232c.84-1.676,1.279-3.528,2.313-5.1a11.8,11.8,0,0,0,1.474-5.043c.135-1.189-.236-2.612-1.569-1.685-1.571,1.092-3.083,3.062-5.2,3.088-1.466.019-1.752-1.087-1.1-2.176a42.175,42.175,0,0,0,2.826-5.6c.824-1.97,1.43-4.009,2.307-5.95a25.551,25.551,0,0,1,1.634-2.945c1.654-2.652,1-5.732.707-8.651-.412-4.075-2.079-13.112-2.971-18.279",
    fill: "#ffaaa9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9611",
    "data-name": "Trazado 9611",
    d: "M408.409,192.125c7.9.588,12.324,2.217,16.547,9.959s9.853,26.569,11.086,30.44a60.06,60.06,0,0,1,2.949,14.448,58.661,58.661,0,0,1,.058,8.464s-1.072,2.073-7.407,2.073-8.2-1.114-8.2-1.114l-2.005-12.082-13.029-28.681Z",
    fill: "#08204a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9612",
    "data-name": "Trazado 9612",
    d: "M316.117,404.1c-.641-.28-1.175,1.333-1.014,2.241.46,2.609,2.964,6.065,7.422,8.676s14.262,4.381,17.145,5.192,7.327,3.844,10.015,5.218c4.9,2.5,8.9,2.213,11.124,1.1a3.336,3.336,0,0,0,1.495-2.212c.585-1.979.542-2.432.318-2.487Z",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9613",
    "data-name": "Trazado 9613",
    d: "M363.911,415.922a25.542,25.542,0,0,1-1.834,7.229,5.64,5.64,0,0,1-4.347,1.572c-3.721-.033-6.966-1.308-10.428-3.3a28.632,28.632,0,0,0-7.06-3.207c-2.991-.789-9.686-2.224-12.648-3.138a21.094,21.094,0,0,1-7.523-4.139c-1.656-1.533-3.959-4.491-4.129-6.211.5-3.737,1.541-5.722,3.962-6.261,2.558-.569,5.71.174,10.058,1.225,1.3.315,2.929.759,3.632.9,2.662.547,5.125,1.131,7.114,1.637a11.647,11.647,0,0,0,5.141.5,3.39,3.39,0,0,0,2.078-1.022c.7-.773,1.113-2.093,1.928-1.913,0,0,13.737,7.166,14.874,7.666,1.313.578-.2,2.231-.818,8.457",
    fill: "#2b454e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9614",
    "data-name": "Trazado 9614",
    d: "M315.942,404.725c.223-2.6,1.136-6,4.2-6.41,4.58-.62,9.056,1.253,13.454,2.278l-5.339-1.227c-6.159-1.291-11.38-2.734-12.313,5.359",
    fill: "#08204a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9615",
    "data-name": "Trazado 9615",
    d: "M332.512,400.1a4.163,4.163,0,0,0-1.482.925,7.627,7.627,0,0,0-1.213,1.472c-.432.679.434,1.122,1.067.386a9.9,9.9,0,0,1,1.694-1.681,2.424,2.424,0,0,1,1.553-.493l.76.161c-.019-.614-1.7-.961-2.379-.77",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9616",
    "data-name": "Trazado 9616",
    d: "M339.319,401.45a1.851,1.851,0,0,0-1.5-.026,3.612,3.612,0,0,0-1.525,1.2A14.312,14.312,0,0,0,335,404.631c-.207.46.92.806,1.21.326a19.83,19.83,0,0,1,1.218-1.814c.234-.289,1.22-1.353,2.034-1.229l.357.093c.056-.165-.128-.351-.271-.438a2.223,2.223,0,0,0-.227-.119",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9617",
    "data-name": "Trazado 9617",
    d: "M343.2,402.581a1.545,1.545,0,0,0-1.011.217,4.164,4.164,0,0,0-.972.957,8.162,8.162,0,0,0-1.1,2.24c-.214.609.956.808,1.126.41a6.36,6.36,0,0,1,1.732-2.849,3.107,3.107,0,0,1,1.292-.7c0-.12-.156-.187-.27-.2a6.625,6.625,0,0,0-.8-.071",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9618",
    "data-name": "Trazado 9618",
    d: "M370.167,392.215s-4.313,13.088-5.627,16.074c-.42.954-2.414.746-3.51.853a12.281,12.281,0,0,0-3.918.833c-3.228,1.638-5.252,1.612-5.35-3.115-.02-.968-.458-1.525-1.64-1.68a7.164,7.164,0,0,1-2.637-.461c-.1-.126.04-.3.168-.4a4.407,4.407,0,0,0,1.97-3.071c1.346-5.6,2.045-10.431,3.511-17.311Z",
    fill: "#ffaaa9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9619",
    "data-name": "Trazado 9619",
    d: "M380.552,262.739s-6.586,7.893-10.568,22.655a341.211,341.211,0,0,0-8.216,41.7c-.95,6.284-1.65,10.77-3.358,22.216-1.423,9.536-7.686,44.994-7.686,44.994s4.593,3.974,8.456,5.436c3.6,1.36,6.924,1.9,8.245,1.36,0,0,4.431-11.379,9.916-26.277a142.323,142.323,0,0,0,6.311-21.034c.717-3.686.543-10.244.473-13.554l29.46-45.508a31.369,31.369,0,0,0,5.5-9.49c3.876-9.727-1.072-23.742-1.072-23.742Z",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9620",
    "data-name": "Trazado 9620",
    d: "M369.984,285.394c-4.7,17.561-7.247,36.381-9.881,54.388-2.7,17.657-6.25,36.877-9.379,54.527,2.759-17.739,6.315-36.9,8.886-54.6,2.775-18,5.3-36.829,10.374-54.314",
    fill: "#08204a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9621",
    "data-name": "Trazado 9621",
    d: "M409.547,275.515H373.363a77.974,77.974,0,0,0-3.379,9.879,321.205,321.205,0,0,0-7.72,38.4c.88,5.923,1.876,12,2.8,16.189,2.43,11.037,3.949,18.833,5.872,23.39s6.541,11,6.56,11.027a140.945,140.945,0,0,0,6.157-20.605c.717-3.685.543-10.243.473-13.553l21.4-33.054,1.664-10.239c5.467-8.911,4.86-15.594,2.361-21.432"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9622",
    "data-name": "Trazado 9622",
    d: "M422.194,412.837c-1.858-2.971-2.863-8.693-6.951-20.318l-15.91,13.043,9.434,14.99a13.742,13.742,0,0,1,.684,2.375c2.024,2.911,12.743-10.09,12.743-10.09",
    fill: "#ffaaa9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9623",
    "data-name": "Trazado 9623",
    d: "M427.809,419.175c-.023-.172.068-1.572.024-1.74-.394-1.509-1.326-1.926-2.523-2.769a18.707,18.707,0,0,1-3.3-2.824c-.4-.556-.479-.844-1.1-1.1a5.859,5.859,0,0,0-4.863.637c-3.439,1.807-4.489,3.982-4.291,6.34.151,1.8.3,4.189-1.284,5.257-.66.445-1.7-2.428-1.7-2.428-.978,1.639.395,3.906,1.111,7.224a13.653,13.653,0,0,1,.1,5.58c-.348,2.913-.751,2.9-2.3,3.1-1.332.175-5.111-.078-7.41,1.527a4.873,4.873,0,0,0-2.321,5.157c.41,1.12,3.855,6.552,16.442,4.523,3.651-.588,11.322-6.328,11.2-6.865a7.228,7.228,0,0,1,.029-1.649c.044-1.287.1-2.573.156-3.86a19.489,19.489,0,0,1,.213-3.677,19.931,19.931,0,0,0,.469-3.04l.723-7.752c.069-.744.726-.915.626-1.649",
    fill: "#2b454e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9624",
    "data-name": "Trazado 9624",
    d: "M429.394,418.665c1.241,1.2.486,4.687-1.178,8.87-.739,1.855-2.115,5.05-1.71,8.446s.475,5-.4,6.591c-1.37,2.489-8.687,5.675-13,6.673a23.8,23.8,0,0,0,4.385-12.456c.433-7.495,1.005-12.326,4.433-15.65,4.333-4.2,7.47-2.474,7.47-2.474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9625",
    "data-name": "Trazado 9625",
    d: "M397.946,443.144s2.525,4.729,12.263,4.575c3.833-.061,5.885-1.928,5.979-7.755.114-7.023.679-14.115,2.95-17.6s5.889-5.177,8.7-4.928a2.692,2.692,0,0,1,1.561,1.23s-2.809-.923-7.178,2.7c-3.226,2.678-4.1,8.269-4.049,15.213.021,2.989.2,6.377-.673,8.645a6.9,6.9,0,0,1-4.65,4.1c-5.295,1.487-12.54-.964-14.372-3.2a3.474,3.474,0,0,1-.526-2.979",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9626",
    "data-name": "Trazado 9626",
    d: "M409.645,435.185a2,2,0,0,0-.788,1.162,3.334,3.334,0,0,0,1.535,3.049c.586.366,1.1.238.166-.993a6.1,6.1,0,0,1-.913-3.218",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9627",
    "data-name": "Trazado 9627",
    d: "M410.169,431.551s-.309.2-.387,1.175a4.774,4.774,0,0,0,1.8,3.134c1.025.5.47-.68.026-1.26a7.657,7.657,0,0,1-1.436-3.049",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9628",
    "data-name": "Trazado 9628",
    d: "M409.823,427.535s-.333.092.022,1.436a4.281,4.281,0,0,0,2.123,1.863c.661.079.981-.251.171-.839-.639-.463-2.192-1.808-2.316-2.46",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9629",
    "data-name": "Trazado 9629",
    d: "M403.407,262.739c1.72,1.762,6,7.667,6.7,16.756a25.112,25.112,0,0,1-5.295,16.561c-1.375,20.16-2.684,58.222-2.684,58.222,4.679,6.608,5.864,10.849,8.948,20.681,1.872,5.968,8.355,29.657,8.355,29.657-9.483,1.426-15.24,9.765-15.24,9.765s-13.145-21.17-21.888-35.9c-6.4-10.778-8.592-15.422-10.737-21.535-1.971-5.616-3.4-12.418-5.317-25.536s-3.8-30.393-4.743-43.306-.4-26.411-.4-26.411Z",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9630",
    "data-name": "Trazado 9630",
    d: "M404.19,414.381c-4.535-7.175-13.484-21.62-17.873-28.876-5.752-9.727-12.162-19.266-15.5-30.175a283.316,283.316,0,0,1-6.026-33.43c-1.408-11.234-2.535-22.5-3.282-33.8.457,5.642,1.012,11.274,1.631,16.9,1.786,16.854,3.96,33.757,8.156,50.2,3.265,10.848,9.629,20.428,15.308,30.14l17.59,29.046",
    fill: "#08204a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9631",
    "data-name": "Trazado 9631",
    d: "M420.5,278.539a7.99,7.99,0,0,1-3.871-2.748,11.089,11.089,0,0,1-1-2.854A30.246,30.246,0,0,0,414,268.092l-1,.446a28.784,28.784,0,0,1,1.567,4.68,11.712,11.712,0,0,0,1.13,3.151,8.9,8.9,0,0,0,4.7,3.258c.038-.362.07-.724.094-1.088"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9632",
    "data-name": "Trazado 9632",
    d: "M394.606,290.092a3.847,3.847,0,0,0,.7-.07c1.582-.35,2.812-1.413,5.263-4.547,1.865-2.387,1.674-4.1,1.36-6.941-.116-1.042-1.215-6.615-1.284-8.084l-1.046.581c.071,1.5,1.128,6.565,1.245,7.623.313,2.823.455,4.112-1.135,6.148-2.266,2.9-3.349,3.868-4.638,4.153-1.249.282-6.782-.636-8.257-1.656-.851-.592-2.278-7.877-3.111-14.287l-1.083.141c.421,3.24,1.924,13.9,3.573,15.044,1.464,1.013,6.217,1.953,8.416,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9633",
    "data-name": "Trazado 9633",
    d: "M384.034,186.245l1.992,14.584,19.811-1.008-2.143-15.794Z",
    fill: "#ffaaa9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9634",
    "data-name": "Trazado 9634",
    d: "M376.146,158.974c-1.522,1.935-6.178,7.194-7.009,8.569l4.436,2.7Z",
    fill: "#ff9090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9635",
    "data-name": "Trazado 9635",
    d: "M376.146,158.973a82.463,82.463,0,0,1-7.009,8.569,47.057,47.057,0,0,1,7.009-8.569",
    fill: "#08204a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9636",
    "data-name": "Trazado 9636",
    d: "M387.16,144.307c-6.122-.658-10.092,3.681-11.871,16.709-.07.51-.826,1.312-1.4,3.261-2.452,8.362-1.08,16.323.333,18.441,3.547,2.852,7.489,3.916,13.2,3.43,4.353-.37,15.455-1.693,21.086-7.57,6.622-6.915,9.966-17.336,5.262-22.743-6.619-7.61-23.242-11.165-26.614-11.528",
    fill: "#ffaaa9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9637",
    "data-name": "Trazado 9637",
    d: "M387.16,144.307c-9.2-.771-10.477,10.471-11.79,17.215-2.51,4.754-2.9,10.468-2.507,15.757a14.533,14.533,0,0,0,1.361,5.439,14.667,14.667,0,0,1-1.6-5.411c-.562-5.357-.218-11.151,2.3-16,1.211-6.775,2.986-18.21,12.236-17",
    fill: "#08204a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9638",
    "data-name": "Trazado 9638",
    d: "M374.225,182.718c.784,1.171,6.389,4.047,9.91,4.271l-.332-2.74a36.622,36.622,0,0,1-9.578-1.531",
    fill: "#ff9090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9639",
    "data-name": "Trazado 9639",
    d: "M385.951,167.14a1.146,1.146,0,0,0,2.045.338,15.065,15.065,0,0,1,2.234-2.588,5.572,5.572,0,0,1,3.784-1.279c5.138.39,3.885,7.16,1.362,9.515-4.128,3.856-6.323.525-6.323.525s-2.963,6.549,1.357,10.375c0,0,7.457,3.224,13.314,1.406,4.383-4.722,7.315-7.7,10.261-11.762,6.981-9.624,6.99-19.139,2.514-21.861.252-3.416-1.6-8.548-8.609-11.512-6.683-2.825-11.155-2.545-15.986-2.277s-10.771,2.473-15.255-1.275a9.177,9.177,0,0,0,.744,8.369,3.034,3.034,0,0,0-2.622,5.471,2.383,2.383,0,0,0-1.093,2.828,2.894,2.894,0,0,0,2.512,1.855,12.219,12.219,0,0,0,3.037-.194c1.409,3.947,5.862,5.327,8.508,5.16-.073-.014-.416.541-.466.613q-.227.331-.42.683a8.372,8.372,0,0,0-1.005,4.639,2.9,2.9,0,0,0,.107.971",
    fill: "#4f3205"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9640",
    "data-name": "Trazado 9640",
    d: "M376.65,136.745a9.275,9.275,0,0,0,.821,8.318l.172.264-.289-.128a2.94,2.94,0,0,0-2.538,5.3l.177.091-.178.087c-2.508,1.6-.667,4.788,2.016,4.579a14.517,14.517,0,0,0,2.4-.179,9.9,9.9,0,0,1-3.609.157c-2.22-.49-3.01-3.561-.891-4.736v.178a3.131,3.131,0,0,1,2.7-5.645l-.117.137a9.078,9.078,0,0,1-.664-8.42",
    fill: "#08204a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9641",
    "data-name": "Trazado 9641",
    d: "M413.909,194.338c5.139,2.876,9.043,12.478,8.664,20.493-.239,5.072-2.022,18.169-3.541,29.749-.478,3.649.974,9.8,1.647,17.206.5,5.489.566,11.327.566,11.327s-6.886,8.526-25.793,9.638c-24.133,1.421-34.822-4.415-34.822-4.415s-.148-19.664.433-35.236c.863-23.093.912-29.848,4.521-37.709,1.194-2.324,2.443-7.5,6.375-8.52,3.115-.81,10.3-2.531,13.146-2.965,4.666,1.2,16.764,1.3,19.76-1.25l-.05-.672c5.192-.062,5.923.58,9.094,2.354",
    fill: "#08204a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9642",
    "data-name": "Trazado 9642",
    d: "M284.6,253.42c.789.181,1.847-.234,3-1.244a15.2,15.2,0,0,0,4.475-8.3c.211-1.516-.024-2.628-.61-3.187l-4.737-4.525a4.218,4.218,0,0,0-4.715-.4c-3.967,2.059-7.183,8.028-6.721,12.473.21,2.014,8.808,5.07,9.311,5.186",
    fill: "#375a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9643",
    "data-name": "Trazado 9643",
    d: "M291.819,243.411a3.05,3.05,0,0,0-5.087-2.74,11.059,11.059,0,0,0-4.746,8.809,3.049,3.049,0,0,0,5.086,2.74,11.057,11.057,0,0,0,4.747-8.809",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9644",
    "data-name": "Trazado 9644",
    d: "M316.617,267.166a2.126,2.126,0,0,0,2.086-.288,6.424,6.424,0,0,0,2.753-5.11,2.125,2.125,0,0,0-.906-1.9l-30.12-17.18a3.042,3.042,0,0,0-2.88.057,6.534,6.534,0,0,0-3.383,6.278,3.041,3.041,0,0,0,1.537,2.437l30.913,15.707",
    fill: "#375a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9645",
    "data-name": "Trazado 9645",
    d: "M321.456,261.768a2.122,2.122,0,0,0-.906-1.9,2.053,2.053,0,0,0-2.088.22,6.373,6.373,0,0,0-2.809,5.213,2.051,2.051,0,0,0,.964,1.865,2.122,2.122,0,0,0,2.085-.288,6.421,6.421,0,0,0,2.754-5.11",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9646",
    "data-name": "Trazado 9646",
    d: "M354.387,257.31c2.723-.909,4.725-4.067,8.634-12.178,4.872-10.109,7.508-12.381,11.087-22.72,3.005-7.575-.969-21.532-2.817-24.447-6.1,2.176-10.34,4.181-14.45,12.723-3.7,7.683-11.088,23.175-14.45,29.989,0,0-19.618,4.23-24.889,4.584a11.273,11.273,0,0,1-5.934-1.109,7.5,7.5,0,0,0-3.567-.843,4.231,4.231,0,0,0-1.429.207,6.83,6.83,0,0,0-2.235,1.746,40.5,40.5,0,0,1-4.131,3c-1.588,1.194-3.463,2.017-5.069,3.21-1.376,1.022-2.9,1.869-3.775,3.412a2.389,2.389,0,0,0-.314.817,1.771,1.771,0,0,0,.476,1.406,2.939,2.939,0,0,0,1.3.784,6.561,6.561,0,0,1,1.982.7c.649.48.7,1.426,1.3,1.992.916.879,2.432.747,3.478,1.467.813.56,1.255,1.579,2.129,2.038a4.137,4.137,0,0,0,1.5.355,25.869,25.869,0,0,0,2.748.374c1.1,0,1.577-.52,2.49-1.028,3.142-1.748,4.838-3.855,10.393-4.225,3.725-.248,32.824-1.344,35.547-2.253",
    fill: "#ffaaa9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9647",
    "data-name": "Trazado 9647",
    d: "M371.877,196.871c-6.633,1.573-10.551,3.958-14.915,11.957-4.04,7.406-14.956,31.093-14.956,31.093l-10.959,3.088a11.32,11.32,0,0,0-1.7,8.871c1.044,5.135,3.322,7.443,3.322,7.443s5.611-.154,15.175-.487c9.421-.327,10.252-2.544,12.35-6.7s14.972-29.26,14.972-29.26,5.167-18.525-3.292-26.008",
    fill: "#08204a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9648",
    "data-name": "Trazado 9648",
    d: "M385.105,193.907c-4.456.822-8.858,1.956-13.237,3.1a20.479,20.479,0,0,0-9.043,4.225c-4.239,3.811-6.484,9.206-9.012,14.2-3.979,8.139-7.75,16.38-11.6,24.584l-.046.1-.1.029L331.1,243.2c-5.338.816-11.022,2.6-16.422,2.1-1.863-.17-3.432-1.38-5.22-1.729a6.609,6.609,0,0,0-2.673.01,5.385,5.385,0,0,0-2.155,1.56c-2.767,2.479-6.078,4.167-9.164,6.14-1.456,1.09-3.17,1.973-4.108,3.6.912-1.643,2.622-2.56,4.059-3.671,3.045-2.008,6.342-3.783,9.034-6.248a5.6,5.6,0,0,1,2.259-1.639,6.846,6.846,0,0,1,2.8-.031c1.835.341,3.339,1.532,5.216,1.7,5.411.452,10.941-1.343,16.28-2.185-.077.02,10.948-3.117,10.932-3.113l-.148.126q5.658-12.361,11.672-24.559c2.572-5.013,4.868-10.43,9.167-14.249a19.242,19.242,0,0,1,9.336-4.2c3.831-1.075,8.855-2.153,13.136-2.9",
    fill: "#08204a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12929",
    "data-name": "Grupo 12929",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12928",
    "data-name": "Grupo 12928"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12927",
    "data-name": "Grupo 12927",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9649",
    "data-name": "Trazado 9649",
    d: "M367.645,339.941a372.471,372.471,0,0,0-10.02,51.93c-.68,5.67-1.54,11.95-5.93,15.59-3.37,2.79-8.02,3.31-12.38,3.63-8.18.58-17.05.63-23.91-3.65.88,2.43,3.27,5.32,7.12,7.58,4.46,2.61,14.26,4.38,17.15,5.19s7.32,3.84,10.01,5.22c4.9,2.5,8.9,2.21,11.13,1.1a3.368,3.368,0,0,0,1.49-2.22c.59-1.98.54-2.43.32-2.48l-.01-.01a29.74,29.74,0,0,0,1.3-5.9c.59-6,2.01-7.75.94-8.39.57-1.44,1.43-3.86,2.29-6.35a2.291,2.291,0,0,0,.28-.08s4.43-11.38,9.92-26.27c.37-1.01.72-1.99,1.06-2.94-3.72-6.37-5.62-10.13-6.84-14.95-1.2-4.73-2.52-9.39-3.92-17m71.35-92.97a60.488,60.488,0,0,0-2.95-14.45c-1.24-3.87-6.87-22.7-11.09-30.44s-8.64-9.37-16.55-9.96v0a27.113,27.113,0,0,0-3.59-.142s.03.38.04.57l-.99-7.27c4.3-4.63,7.21-7.6,10.12-11.61,6.98-9.63,6.99-19.14,2.51-21.86.26-3.42-1.59-8.55-8.6-11.51a30.359,30.359,0,0,0-7-2.08,36.4,36.4,0,0,0-6.94,1.51c-3.11,1-6.2,2.53-8.18,5.13-1.72,2.28-2.43,5.14-3.1,7.91-2.15,8.89-4.3,17.95-3.59,27.06a10.369,10.369,0,0,0,1.12,4.47,6.132,6.132,0,0,0,3.93,2.68s4.31.28,6.47.32c.3,1.84.73,4.6,1.03,6.44a3.061,3.061,0,0,1-.08,1.85,3,3,0,0,1-2.03,1.27c-7.82,2.15-16.94,2.34-22.44,8.3a28.7,28.7,0,0,0-4.6,7.8q-4.29,9.45-8.58,18.89c-1.86,4.11-3.85,8.38-7.4,11.16-6.41,5.02-15.56,3.66-23.46,5.61-5.73,1.42-10.83,4.61-16.5,6.19-1.3.37-2.6.72-3.92.98-1.38.27-2.78.15-4.16.36a2.525,2.525,0,0,0-2.21,1.95,3.556,3.556,0,0,0,.27,1.61,3.842,3.842,0,0,0,1.31,1.68,5.456,5.456,0,0,1,1.74.66c.82.56,1.26,1.58,2.13,2.04a4.064,4.064,0,0,0,1.5.35,23.566,23.566,0,0,0,2.75.37c1.1,0,1.58-.52,2.49-1.02.25-.14.48-.28.71-.42,2.72-1.65,4.57-3.47,9.69-3.81.25-.02.6-.04,1.06-.06,2.32-.12,7.11-.33,12.42-.58.22.27.35.4.35.4s5.61-.15,15.17-.48c9.42-.33,10.25-2.55,12.35-6.7.16-.31.38-.74.64-1.26v.05c3.07-5.97,8.53-16.73,10.33-20.24,0,0-.66,28.97-.59,41.59.13,23.47,3.81,46.75,7.47,69.93.91,5.7,3.33,11.12,5.36,16.55,2.24,6.01,4.55,11.99,7.03,17.9a219.294,219.294,0,0,0,17.22,33.67,35.779,35.779,0,0,1,3.95,7.23c1.26,3.61,1.19,7.53,1.07,11.34a27.752,27.752,0,0,1-1.35,9.26c-2.04,5.34-8.95,5.85-13.27,2.7a4.423,4.423,0,0,0-.11,2.28,3.49,3.49,0,0,0,.53,2.98c1.83,2.24,9.07,4.69,14.37,3.2.09-.02.18-.06.26-.08,4.31-.99,11.63-4.18,13-6.67.88-1.59.81-3.2.4-6.59s.97-6.59,1.71-8.45c1.67-4.18,2.42-7.66,1.18-8.87a2.735,2.735,0,0,0-1.56-1.23c-.4-1.5-1.33-1.92-2.52-2.76a18.65,18.65,0,0,1-3.31-2.83,3.183,3.183,0,0,0-.76-.92c-.64-1.54-1.26-3.58-2.07-6.25a2.388,2.388,0,0,1,.26-.05s-6.49-23.69-8.36-29.66c-3.08-9.83-4.27-14.07-8.95-20.68,0,0,.85-24.65,1.9-44.78l9.56-14.77a28.609,28.609,0,0,0,4.52-7.218c-.027.057-.053.122-.08.178a1.743,1.743,0,0,0,.58.07c2.12-.02,3.63-1.99,5.2-3.09a1.066,1.066,0,0,1,.98-.24c.04-.02.07-.05.11-.07,1.69-.81,1.79,2.97,1.76,3.81a16.941,16.941,0,0,1-1.38,5.58c-1.18,2.94-2.67,5.9-2.53,9.06a2.372,2.372,0,0,0,.09.65c.7-.35.96-1.49,1.33-2.09a5.4,5.4,0,0,1,1.93-1.65,23.832,23.832,0,0,0,2.24-2.13c.74-.64,1.88-.54,2.74-1.19.77-.58.73-1.48,1.27-2.14.51-.64,1.37-.85,1.92-1.53a7.709,7.709,0,0,0,1.65-3.64c.38-2.83,1.11-5.57,1.1-8.42-.01-2.74-.03-5.33.15-8.04.27-4.23,1.13-11.06,1.47-16.74a1.67,1.67,0,0,0,.41-.46,59.21,59.21,0,0,0-.05-8.46m-10.62,22.07c-.58,2.15-2.24,3.79-3.51,5.61-2.54,3.64-3.59,8.17-6.24,11.74,0,.01-.01.01-.02.02l-.01.01q.248-.57.49-1.18a26.312,26.312,0,0,0,1.39-11.33,7.47,7.47,0,0,0,.77-.8s-.07-5.84-.57-11.32c-.67-7.41-2.12-13.56-1.64-17.21.57-4.347,1.178-8.907,1.726-13.177l0,.007v.01a77.638,77.638,0,0,1,4.01,9.37c2.7,7.85,3.37,16.21,3.8,24.44a12.144,12.144,0,0,1-.2,3.81"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12939",
    "data-name": "Grupo 12939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12938",
    "data-name": "Grupo 12938",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12934",
    "data-name": "Grupo 12934",
    opacity: 0.51,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12933",
    "data-name": "Grupo 12933"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12932",
    "data-name": "Grupo 12932",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9650",
    "data-name": "Trazado 9650",
    d: "M98.551,150.814l3.294,50.5,6.973-3.982.86,13.183-6.973,3.983,1.071,16.425L92.1,237.6,91.028,221.17,65.687,235.641l-.9-13.8q3.025-7.114,6.232-15.35T77.164,189.8q2.937-8.459,5.406-16.735t4.1-15.466ZM76.3,215.9l13.867-7.919L88.342,180q-1.182,4.443-2.6,9.106t-3.008,9.31q-1.592,4.646-3.235,9.09T76.3,215.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9651",
    "data-name": "Trazado 9651",
    d: "M136.587,213.637q-20.76,11.858-23.379-28.312-1.359-20.838,3.544-34.967t15.566-20.218q20.272-11.577,22.936,29.26,1.328,20.336-3.5,34.334t-15.167,19.9m-3.958-69.71q-8.313,4.747-6.435,33.518,1.767,27.1,9.917,22.441,7.946-4.538,6.124-32.472t-9.606-23.487"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9652",
    "data-name": "Trazado 9652",
    d: "M194.076,96.261l3.293,50.5,6.974-3.982.859,13.183-6.973,3.983,1.071,16.425-11.677,6.669-1.071-16.426-25.341,14.472-.9-13.8q3.025-7.116,6.232-15.351t6.145-16.691q2.938-8.46,5.407-16.735t4.1-15.467Zm-22.25,65.091,13.866-7.919-1.825-27.99q-1.184,4.445-2.6,9.107t-3.008,9.309q-1.59,4.646-3.234,9.091t-3.195,8.4"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12937",
    "data-name": "Grupo 12937",
    opacity: 0.51,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12936",
    "data-name": "Grupo 12936"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12935",
    "data-name": "Grupo 12935",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9653",
    "data-name": "Trazado 9653",
    d: "M72.724,142.673l.558,5.352-1.508.855-1.538-14.763L73,132.549a2.3,2.3,0,0,1,2.56-.2,3.808,3.808,0,0,1,1.213,2.845,8.312,8.312,0,0,1-.536,4.033,5.319,5.319,0,0,1-2.3,2.753Zm-.77-7.392.562,5.394.98-.555a3.2,3.2,0,0,0,1.406-1.571A4.685,4.685,0,0,0,75.2,136.2q-.271-2.6-2.142-1.543Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9654",
    "data-name": "Trazado 9654",
    d: "M83.85,142.037l-1.432.811-.171-1.647-.026.014a4.232,4.232,0,0,1-1.781,3.016,1.3,1.3,0,0,1-1.593.009,2.834,2.834,0,0,1-.776-1.926,4.991,4.991,0,0,1,1.762-4.684l1.888-1.538q-.234-2.254-1.558-1.506a5.045,5.045,0,0,0-1.965,2.488l-.217-2.09a6.248,6.248,0,0,1,2.276-2.337q2.469-1.4,2.878,2.534ZM81.5,126.514l-1.467,4.409-1.1.62,1.188-4.251Zm.387,11.153-1.336,1.083a3.328,3.328,0,0,0-.905,1.043,2.593,2.593,0,0,0-.188,1.462,1.281,1.281,0,0,0,.41.93.716.716,0,0,0,.837-.021,2.472,2.472,0,0,0,1.036-1.4,4.907,4.907,0,0,0,.242-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9655",
    "data-name": "Trazado 9655",
    d: "M91.492,136.813q.606,5.807-3,7.851a3.614,3.614,0,0,1-2.293.568l-.227-2.182a2.552,2.552,0,0,0,2.133-.163q2.322-1.315,1.937-5.011l-.12-1.153-.026.014A4.6,4.6,0,0,1,87.9,140a1.5,1.5,0,0,1-2.065-.317,6.075,6.075,0,0,1-1.122-3.361,11.942,11.942,0,0,1,.338-4.716,4.551,4.551,0,0,1,1.985-2.8,1.381,1.381,0,0,1,2.093.625l.025-.015-.152-1.462,1.476-.836Zm-1.878-3.155-.143-1.368a2.623,2.623,0,0,0-.652-1.643A.929.929,0,0,0,87.6,130.5a2.772,2.772,0,0,0-1.209,1.748,8.1,8.1,0,0,0-.182,3.073,4.256,4.256,0,0,0,.714,2.229.928.928,0,0,0,1.3.249,2.7,2.7,0,0,0,1.147-1.594,6.043,6.043,0,0,0,.24-2.551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9656",
    "data-name": "Trazado 9656",
    d: "M92.917,123.391a.547.547,0,0,1-.66-.029,1.154,1.154,0,0,1-.359-.821,2.331,2.331,0,0,1,.156-1.124,1.426,1.426,0,0,1,.58-.744.556.556,0,0,1,.676.032,1.167,1.167,0,0,1,.363.83,2.267,2.267,0,0,1-.161,1.1,1.439,1.439,0,0,1-.6.757m2.06,12.341-1.476.836-1.1-10.541,1.476-.836Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9657",
    "data-name": "Trazado 9657",
    d: "M102.707,131.352l-1.476.837-.619-5.94q-.308-2.954-1.6-2.222a2.462,2.462,0,0,0-1.028,1.448,5.467,5.467,0,0,0-.224,2.314l.626,6.011-1.482.84-1.1-10.541,1.482-.84.182,1.75L97.5,125a4.53,4.53,0,0,1,1.9-3.195,1.242,1.242,0,0,1,1.739.2,5.574,5.574,0,0,1,.9,2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9658",
    "data-name": "Trazado 9658",
    d: "M109.509,127.5l-1.432.812-.172-1.648-.025.014a4.234,4.234,0,0,1-1.781,3.016,1.3,1.3,0,0,1-1.593.009,2.837,2.837,0,0,1-.776-1.927,4.992,4.992,0,0,1,1.762-4.683l1.888-1.538q-.234-2.254-1.558-1.505a5.037,5.037,0,0,0-1.965,2.487l-.217-2.09a6.241,6.241,0,0,1,2.276-2.337q2.469-1.4,2.878,2.534Zm-1.965-4.37-1.336,1.084a3.315,3.315,0,0,0-.9,1.042,2.6,2.6,0,0,0-.188,1.463,1.276,1.276,0,0,0,.41.929.716.716,0,0,0,.837-.021,2.472,2.472,0,0,0,1.036-1.4,4.907,4.907,0,0,0,.242-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9659",
    "data-name": "Trazado 9659",
    d: "M120.693,121.16l-1.477.837-.618-5.94q-.308-2.954-1.6-2.222a2.46,2.46,0,0,0-1.029,1.448,5.5,5.5,0,0,0-.224,2.314l.627,6.011-1.483.84-1.1-10.541,1.483-.84.182,1.75.026-.014a4.53,4.53,0,0,1,1.9-3.195,1.244,1.244,0,0,1,1.74.2,5.571,5.571,0,0,1,.9,2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9660",
    "data-name": "Trazado 9660",
    d: "M125.408,118.75a2.011,2.011,0,0,1-2.563-.112,5.281,5.281,0,0,1-1.308-3.407,10,10,0,0,1,.507-4.681,5.477,5.477,0,0,1,2.373-2.926,1.952,1.952,0,0,1,2.531.1,5.74,5.74,0,0,1,1.272,3.542,9.947,9.947,0,0,1-.5,4.561,5.321,5.321,0,0,1-2.313,2.919m-.882-9.17a2.906,2.906,0,0,0-1.266,1.752,7.361,7.361,0,0,0-.221,2.982,4.107,4.107,0,0,0,.78,2.323,1.073,1.073,0,0,0,1.461.179,2.777,2.777,0,0,0,1.242-1.694,7.425,7.425,0,0,0,.19-2.933,4.675,4.675,0,0,0-.748-2.422,1.022,1.022,0,0,0-1.438-.187"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9661",
    "data-name": "Trazado 9661",
    d: "M138.891,105.953l-4.441,2.516a2.876,2.876,0,0,0,.792,1.939,1.291,1.291,0,0,0,1.542-.034,4.819,4.819,0,0,0,1.81-2.094l.2,1.925a5.836,5.836,0,0,1-2.258,2.24,1.822,1.822,0,0,1-2.406-.158,5.989,5.989,0,0,1-1.238-3.577,10.126,10.126,0,0,1,.482-4.521,5,5,0,0,1,2.075-2.816,1.614,1.614,0,0,1,2.213.218,6.191,6.191,0,0,1,1.133,3.446Zm-1.6-.881a3.35,3.35,0,0,0-.583-1.79.792.792,0,0,0-1.094-.138,2.44,2.44,0,0,0-1,1.363,6.291,6.291,0,0,0-.339,2.274Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9662",
    "data-name": "Trazado 9662",
    d: "M146.581,106.491l-1.476.836-.619-5.94q-.307-2.954-1.6-2.222a2.458,2.458,0,0,0-1.028,1.449,5.461,5.461,0,0,0-.224,2.313l.626,6.011-1.482.841-1.1-10.541,1.482-.841.183,1.75.025-.014a4.532,4.532,0,0,1,1.9-3.195,1.243,1.243,0,0,1,1.739.2,5.569,5.569,0,0,1,.9,2.911Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9663",
    "data-name": "Trazado 9663",
    d: "M152.994,102.345a4.892,4.892,0,0,1-1.775,1.78,1.949,1.949,0,0,1-2.494-.14,5.1,5.1,0,0,1-1.288-3.3,10.335,10.335,0,0,1,.522-4.729,5.538,5.538,0,0,1,2.4-3.031,2.5,2.5,0,0,1,1.624-.385l.232,2.223a1.462,1.462,0,0,0-1.537,0,3.371,3.371,0,0,0-1.426,1.894,6.757,6.757,0,0,0-.319,3.02,3.61,3.61,0,0,0,.833,2.265,1.245,1.245,0,0,0,1.609.09,3.752,3.752,0,0,0,1.406-1.766Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9664",
    "data-name": "Trazado 9664",
    d: "M157.423,100.609a2.011,2.011,0,0,1-2.563-.112,5.27,5.27,0,0,1-1.308-3.406,9.992,9.992,0,0,1,.507-4.682,5.468,5.468,0,0,1,2.373-2.926,1.95,1.95,0,0,1,2.53.1,5.727,5.727,0,0,1,1.272,3.542,9.947,9.947,0,0,1-.5,4.561,5.321,5.321,0,0,1-2.313,2.919m-.882-9.17a2.909,2.909,0,0,0-1.266,1.752,7.363,7.363,0,0,0-.222,2.983,4.106,4.106,0,0,0,.781,2.322,1.072,1.072,0,0,0,1.461.179,2.777,2.777,0,0,0,1.242-1.694,7.44,7.44,0,0,0,.19-2.932,4.7,4.7,0,0,0-.748-2.423,1.022,1.022,0,0,0-1.438-.187"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9665",
    "data-name": "Trazado 9665",
    d: "M168.091,94.3l-1.476.837L166,89.2q-.308-2.953-1.6-2.222a2.462,2.462,0,0,0-1.028,1.449,5.461,5.461,0,0,0-.224,2.313l.626,6.011-1.482.84-1.1-10.541,1.482-.84.182,1.75.026-.014a4.53,4.53,0,0,1,1.9-3.195,1.243,1.243,0,0,1,1.739.2,5.574,5.574,0,0,1,.9,2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9666",
    "data-name": "Trazado 9666",
    d: "M173.316,91.222a3.158,3.158,0,0,1-1.1,1q-1.9,1.074-2.2-1.87l-.621-5.961L168.3,85l-.2-1.873,1.088-.616-.254-2.44,1.4-1.516.324,3.12,1.56-.884.2,1.873-1.559.884.549,5.271a2.356,2.356,0,0,0,.35,1.219c.167.188.415.19.741,0a1.533,1.533,0,0,0,.613-.719Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9667",
    "data-name": "Trazado 9667",
    d: "M177.517,80.206a.776.776,0,0,0-.8.1,2.482,2.482,0,0,0-1,1.578,7.66,7.66,0,0,0-.167,2.853l.526,5.044-1.477.836-1.1-10.541,1.476-.836.227,2.172.025-.015a6.615,6.615,0,0,1,.484-2.112,2.417,2.417,0,0,1,.938-1.19.825.825,0,0,1,.63-.151Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9668",
    "data-name": "Trazado 9668",
    d: "M184.423,85.048l-1.432.812-.171-1.648-.026.014a4.229,4.229,0,0,1-1.781,3.015,1.3,1.3,0,0,1-1.593.01,2.837,2.837,0,0,1-.776-1.927,4.989,4.989,0,0,1,1.762-4.683l1.888-1.538q-.234-2.254-1.558-1.5a5.037,5.037,0,0,0-1.965,2.487L178.554,78a6.251,6.251,0,0,1,2.276-2.338q2.469-1.4,2.878,2.535Zm-1.965-4.37-1.336,1.084a3.315,3.315,0,0,0-.9,1.042,2.6,2.6,0,0,0-.188,1.462,1.281,1.281,0,0,0,.41.93.714.714,0,0,0,.837-.022,2.466,2.466,0,0,0,1.036-1.4,4.907,4.907,0,0,0,.242-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9669",
    "data-name": "Trazado 9669",
    d: "M192.146,80.671l-1.476.837-.186-1.791-.025.014a4.558,4.558,0,0,1-1.983,3.281,1.492,1.492,0,0,1-2.072-.324,6.353,6.353,0,0,1-1.124-3.446,11.5,11.5,0,0,1,.362-4.644,4.57,4.57,0,0,1,1.964-2.78,1.365,1.365,0,0,1,2.093.625l.026-.014-.681-6.528,1.477-.837Zm-1.958-3.992-.144-1.379a2.633,2.633,0,0,0-.65-1.649.939.939,0,0,0-1.233-.13,2.762,2.762,0,0,0-1.2,1.736,7.946,7.946,0,0,0-.186,3.038,4.377,4.377,0,0,0,.72,2.28.937.937,0,0,0,1.321.236,2.662,2.662,0,0,0,1.135-1.595,6.123,6.123,0,0,0,.234-2.537"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9670",
    "data-name": "Trazado 9670",
    d: "M199.076,76.745l-1.432.811-.171-1.647-.026.014a4.229,4.229,0,0,1-1.781,3.015,1.3,1.3,0,0,1-1.593.01,2.837,2.837,0,0,1-.776-1.927,4.989,4.989,0,0,1,1.762-4.683l1.888-1.538q-.234-2.255-1.558-1.505a5.037,5.037,0,0,0-1.965,2.487l-.217-2.09a6.251,6.251,0,0,1,2.276-2.338q2.469-1.4,2.878,2.535Zm-1.965-4.37-1.335,1.083a3.32,3.32,0,0,0-.906,1.043,2.6,2.6,0,0,0-.188,1.462,1.281,1.281,0,0,0,.41.93.714.714,0,0,0,.837-.022,2.466,2.466,0,0,0,1.036-1.4,4.907,4.907,0,0,0,.242-2.18Z"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgOscura);
export default __webpack_public_path__ + "static/media/img-oscura.875b9a0691eddbe5446f98dcbf16d625.svg";
export { ForwardRef as ReactComponent };